interface CompletionBarProps {
  percent: number
  label?: string
}

export function CompletionBar({ percent, label }: CompletionBarProps) {
  const clamped = Math.max(0, Math.min(100, Math.round(percent)))
  const color = clamped >= 80 ? 'success' : clamped >= 40 ? 'warning' : 'danger'

  return (
    <div>
      {label && (
        <div className="d-flex justify-content-between mb-1">
          <span className="fs-12 text-muted">{label}</span>
          <span className="fs-12 fw-medium">{clamped}%</span>
        </div>
      )}
      <div
        className="progress"
        style={{ height: 6 }}
        role="progressbar"
        aria-valuenow={clamped}
        aria-valuemin={0}
        aria-valuemax={100}
      >
        <div className={`progress-bar bg-${color}`} style={{ width: `${clamped}%` }} />
      </div>
    </div>
  )
}
